import { useOnClickOutside } from "../../../../../hooks/useOnClickOutside.js";
import { AppShellViewModel } from "../../../viewmodels/AppShellViewModel.js";
import { AppItem } from "./AppItem.js";
import { useRef, useState } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useSingleton } from "mvc-kit/react";
import { MdExpandMore } from "react-icons/md";
// src/modules/AppWrapper2/components/AppNav/components/AppPicker.tsx
function AppPicker({ compact }) {
	const [isOpen, setIsOpen] = useState(false);
	const shellVM = useSingleton(AppShellViewModel);
	const appPickerList = shellVM.appPickerList;
	const currentApp = shellVM.currentApp;
	const user = shellVM.user;
	const ref = useRef(null);
	useOnClickOutside(ref, () => setIsOpen(false));
	if (!appPickerList.length || !user) return null;
	const canSwitchApps = user.anp.roles.length >= 2;
	const swatch = /* @__PURE__ */ jsx("span", {
		style: { color: currentApp?.color },
		children: /* @__PURE__ */ jsx(Icon, {
			className: "app-icon-enamel",
			Icon: currentApp?.icon,
			size: "base"
		})
	});
	return /* @__PURE__ */ jsxs("div", {
		className: "relative flex items-center",
		ref,
		children: [/* @__PURE__ */ jsx(Button, {
			className: "group",
			disabled: !canSwitchApps,
			onClick: () => setIsOpen(!isOpen),
			size: "sm",
			subtle: true,
			variant: "neutral",
			children: compact ? /* @__PURE__ */ jsxs("div", {
				className: "relative",
				children: [swatch, canSwitchApps && /* @__PURE__ */ jsx("div", {
					className: "bg-surface-strong border-border -bottom-xxs -right-xxs absolute flex items-center justify-center rounded-full border",
					children: /* @__PURE__ */ jsx(Icon, {
						Icon: MdExpandMore,
						size: "xs"
					})
				})]
			}) : /* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex items-center",
				children: [
					swatch,
					/* @__PURE__ */ jsx("span", {
						className: "text-color-strong text-sm font-semibold tracking-wide",
						children: currentApp?.name
					}),
					canSwitchApps && /* @__PURE__ */ jsx(Icon, {
						className: classnames("text-color-strong transition-transform", { "rotate-180": isOpen }),
						Icon: MdExpandMore,
						size: "sm"
					})
				]
			})
		}), isOpen && /* @__PURE__ */ jsxs("div", {
			className: "z-dropdown mt-xs bg-surface-strong p-sm sm:p-lg absolute top-full w-screen max-w-[28rem] rounded-md shadow sm:px-0 lg:max-w-[900px]",
			children: [/* @__PURE__ */ jsx("div", {
				className: "px-base text-color-subtle text-sm font-bold tracking-wider uppercase",
				children: "Apps"
			}), /* @__PURE__ */ jsx("div", {
				className: "mt-xs gap-base px-sm grid w-full lg:grid-cols-2",
				children: appPickerList.map(({ color, description, icon, id, link, name }) => /* @__PURE__ */ jsx(AppItem, {
					active: currentApp?.id === id,
					color,
					description,
					icon,
					link,
					name,
					onClick: () => {
						window.location.href = link;
					}
				}, link))
			})]
		})]
	});
}
export { AppPicker };

//# sourceMappingURL=AppPicker.js.map